import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/changes/license.changes.decide.mutation.gql"
import type {
  FeatureSurfaceDecideMutation,
  FeatureSurfaceDecideMutationVariables,
} from "@/v2-backoffice-client/license/changes/__types__/license.changes.decide.mutation"

type Options = MutationHookOptions<
  FeatureSurfaceDecideMutation,
  FeatureSurfaceDecideMutationVariables
>

export function useFeatureSurfaceDecideMutation(options?: Options) {
  return useMutation<
    FeatureSurfaceDecideMutation,
    FeatureSurfaceDecideMutationVariables
  >(mutation, options)
}
